// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect,createContext,useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
//import Ts from "./TS.tsx";
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import {LoginContext,LoadingContext} from '../Default';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import {  colors } from '@mui/material';
//import { data, type Person } from './makeData';
import {type C2List}  from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import {stix} from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import AvatarGroup from '@mui/material/AvatarGroup';
import Avatar from '@mui/material/Avatar';
import './News.css';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import Looks6Icon from '@mui/icons-material/Looks6';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CardMedia from '@mui/material/CardMedia';
import { Crown } from 'lucide-react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { Helmet } from 'react-helmet-async';

//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();

const handleReady = () => {

};

const StyledTypography = styled(Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 5,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const TitleTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  textDecoration: 'none',
  '&:hover': { cursor: 'pointer' },
  '& .arrow': {
    visibility: 'hidden',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '&:hover .arrow': {
    visibility: 'visible',
    opacity: 0.7,
  },
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'hsla(210, 98%, 48%, 0.5)',
    outlineOffset: '3px',
    borderRadius: '8px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    width: 0,
    height: '1px',
    bottom: 0,
    left: 0,
    backgroundColor: (theme.vars || theme).palette.text.primary,
    opacity: 0.3,
    transition: 'width 0.3s ease, opacity 0.3s ease',
  },
  '&:hover::before': {
    width: '100%',
  },
}));
function divideAndAddOne(dividend, divisor) {
  const quotient = Math.floor(dividend / divisor); // 商を切り捨て
  const remainder = dividend % divisor;           // 余りを計算
  return {
    quotientPlusOne: quotient + 1,                // 商にプラス1
    remainder: remainder                          // 余り
  };
}

export default function Column() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
    const useQuery = () => {
      return new URLSearchParams(useLocation().search);
    }
  const query = useQuery();
  const queryId = query.get('_id') || null;
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  const [posts,setPosts] = React.useState<Post[]>([]);
  const [posts2,setPosts2] = React.useState<Post[]>([]);
  const [postsSeo,setPostsSeo] = React.useState<Post[]>([]);
  const [postsSeo2,setPostsSeo2] = React.useState<Post[]>([]);
  const [postsSeo3,setPostsSeo3] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const {login,setLogain} = useContext(LoginContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [reload,setReload] = React.useState(0);
  const [keyword2,setKeyword2] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : intl.formatMessage({ id: "langID00089" }));
  const [focusedCardIndex, setFocusedCardIndex] = React.useState<number | null>(null,);
  const [dispDate, setDispDate] = React.useState("1990/01/01");
  const [dispTitle, setDispTitle] = React.useState("");
  const [dispTag, setDispTag] = React.useState("");
  const [dispContent, setDispContent] = React.useState("");
  const [dispLink, setDispLink] = React.useState("");
  const [pageCount, setPageCount] = React.useState(1);
  const [page, setPage] = React.useState(1);
  const element = React.useRef(null);

function Author(props: { authors: string[], date: string }){
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}
      >
        <Typography variant="caption">
          {/* {props.authors.map((author) => author).join(', ')} */}
            {(() => {
                             let tags = [];
                             for(let i in props.authors){
                                 tags.push(<Button  to="/News" state={{keyword:'#'+props.authors[i]}} noWrap size="small" style={{fontSize: '1em' , color: 'black'}} id={props.authors[i]} onClick=
                                          {e => {
                                                 // e.keyCodeは常に0になる
                                                 setKeyword("#"+props.authors[i]);
                                                 reloadChange();
                                                 setKeyword2("#"+props.authors[i]);
                                               }} >#{props.authors[i]} </Button>)
                               }
                               return tags;
              })()}

        </Typography>
      </Box>
      <Typography variant="caption">{props.date}</Typography>
    </Box>
  );
}


  const handleClose = () => {
    setOpen(false);
  };
  const handleFocus = (index: number) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };
  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };
  const handleChangePage = (event, index) => {
    //ページ移動時にページ番号を更新
    setPage(index);
  }
  
  type CircledDigitProps = {
  num: number
} & BoxProps
  
  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  const reloadChange = () => {
    if(keyword==""){
      setKeyword2(intl.formatMessage({ id: "langID00089" }));
    }else{
      setKeyword2(keyword);
    }
    const i = reload+1;
    setReload(i);
  }

  const params = { // 渡したいパラメータをJSON形式で書く
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);
   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {

    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Colmn Button",
      action: "Search Colmn Button",
      label: keyword, // Optional
    });
    //const aaa = document.getElementById("sc");
    //aaa?.click();
    reloadChange();
     //setRefreshKey(old => old + 1)
  };
    return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resData2 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_RSS_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "18"
      }
  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
      return [];
    });;
    setLoading(false);
    }catch{
      setLoading(false);
      return [];
    }
};
const resData = async (): Promise<Post[]> => {
  const url = process.env.REACT_APP_RSS_API_URL;
  try{
    let bodyData;
    if(keyword == ""){
    bodyData= {
    category: "14",
    keyword: keyword,
    page:page,
  };
    }else if(keyword.indexOf("#") === 0){
      const keywordSub = keyword.replace("#","");
    bodyData= {
    category: "16",
    keyword: keywordSub,
    page:page
  };
    }else{
    bodyData= {
    category: "15",
    keyword: keyword,
    page:page
    };
    }

var getParams = new URLSearchParams(params);
 const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
      });
var params_str = params.toString();
setLoading(true);
return fetch(url , {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(bodyData)
  })
  .then((response) => {
    if (!response.ok ){
      setLoading(false);
      throw new Error('status is not 200');
    }
    return response.json();
  })
  .then(jsondata => {
    setLoading(false);
    return jsondata;
  })
  .catch(error => {
    setLoading(false);
    return [];
  });;
  }catch{
    setLoading(false);
    return [];
  }
};

const REG_DETECT_SCRIPT_TAGS = "/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gmi";

function extractLocalContents(textareaContents) {
  return textareaContents.replace(REG_DETECT_SCRIPT_TAGS, (match) => {
    const scriptFragment = document.createRange().createContextualFragment(match);
    const scriptElement = scriptFragment.querySelector('script')
    if (scriptElement.src === '') return match
    return ''
  })
}

function extractExternalScriptElements(textareaContents) {
  const scriptElements = textareaContents.match(REG_DETECT_SCRIPT_TAGS)
  if (!scriptElements) return []
  return scriptElements.map((match) => {
    const scriptFragment = document.createRange().createContextualFragment(match);
    return scriptFragment.querySelector('script')
  }).filter(scriptElement => scriptElement.src !== '')
}


  useEffect(() => {
    (async function () {
      var res =[];
      const data = await resData();
      // for(var i in data){
      //   if(data[i].ver !==999999){
      //     if(!res.some(member => member.id === data[i].id)){
      //       res.push(data[i]);
      //     }
      //   }
      // }
      setPosts(data);
      setLoading(false);
      if(data.length == 0){
        setPageCount(0);
      }else{
        setPageCount(Math.ceil(data[0].count/9));
      }

    })();
   }, [reload,page]);
         useEffect(() => {
         (async function () {
           var res =[];
           const data = await resSeoData();
           setPostsSeo(data);
         })();
        }, []);
   
       const resSeoData = async (): Promise<Post[]> => {
       const url = process.env.REACT_APP_SEO_API_URL;
       try{
         let bodyData;
         bodyData= {
         category: "24",
         keyword: "news"
         }
   
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
               "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
               'Access-Control-Allow-Credentials': 'true'
           });
     var params_str = params.toString();
     return fetch(url , {
         method: 'POST',
         headers: headers,
         body: JSON.stringify(bodyData)
       })
       .then((response) => {
         if (!response.ok ){
           throw new Error('status is not 200');
         }
         return response.json();
       })
       .then(jsondata => {
         return jsondata;
       })
       .catch(error => {
       });
       }catch{
       }
   };
   
    useEffect(() => {
    (async function () {
      if(queryId!=null){
      var res =[];
      const data = await resSeoData2();
      setPostsSeo2(data);
      }
    })();
   }, []);
   
    const resSeoData2 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "25",
      keyword: queryId
      }

   var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });
    }catch{
    }
};

    useEffect(() => {
    (async function () {
      var res =[];
      const data = await resSeoData3();
      setPostsSeo3(data);
    })();
   }, []);
   
    const resSeoData3 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "26",
      }

   var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });
    }catch{
    }
};



   useEffect(() => {
    (async function () {
      var res =[];
      const data2 = await resData2();
      // for(var i in data){
      //   if(data[i].ver !==999999){
      //     if(!res.some(member => member.id === data[i].id)){
      //       res.push(data[i]);
      //     }
      //   }
      // }
      setPosts2(data2);
      setLoading(false);
    })();
   }, [reload]);
   
     useEffect(() => {
       if(open){
    (async () => {
      const localContents = await extractLocalContents(dispContent)
      const externalScriptElements = await extractExternalScriptElements(dispContent)
      if (externalScriptElements) {
        await Promise.all(externalScriptElements.map((scriptElement) => {
          if (isScriptAlreadyInserted(scriptElement)) {
            return Promise.resolve()
          }

          return new Promise((resolve) => {
            scriptElement.addEventListener('load', resolve)
            document.head.appendChild(scriptElement)
          })
        }))
      }
        element.current.appendChild(document.createRange().createContextualFragment(localContents))

    })();
       }
   }, [open]);
  const columns = useMemo<MRT_ColumnDef<C2List>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'ip',
        header: '',
        size: 50,
        grow: false,
        Cell: ({ cell ,row}) => (
        <div >
           <Box noWrap="true"
        sx={{
          display: 'flex',
          position: 'sticky',
          justifyContent: 'flex-start',
        }}
        
      >
          <Box noWrap
        sx={{
          display: 'flex',
          left: '10px',
          position: 'sticky',
          width: '100%',
          marginLeft: '30px',
          justifyContent: 'flex-start'
        }}
      >
                <img
                  height={90}
                  width={90}
                  src={cell.row.original.thumbnail}
                  loading="lazy"
                />
        <Box noWrap sx={{ textAlign: 'left',marginLeft: '40px',display: 'block' }} component="span" >
          <Typography noWrap variant="h4" noWrap="true" style={{ maxWidth: '1300px' }}    sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }}>
            {(() => {
                    return <Button component={Link} title={cell.row.original.title} size="small"  fullWidth noWrap sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
   }} labelStyle={{paddingLeft: 0, paddingRight: 0}} style={{  overflow: "hidden",
  display: "block",
  mx: 'auto',height:"100%",color: 'black',fontSize: '0.8em',textOverflow: 'ellipsis',overflow: 'hidden'}} id={cell.row.original.title} to="/News"  state={{keyword:keyword,category:"find",table:cell.row.original,bf:"nor"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{cell.row.original.title}  </Button>;
            })()}
            </Typography>
          <Typography component='p' variant="h6" noWrap="true" style={{ maxWidth: '1200px',justifyContent: 'space-between'}} sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }} >
            {(() => {
                const tags = [];
                for(let tag in cell.row.original.tag){
                if(tag==5){
                  tags.push(<br/>);
                }
                  tags.push(<Button component={Link}  size="small" style={{  flexWrap: 'wrap',overflowWrap:'break-word',fontSize: '1em' , color: 'black'}} id={cell.row.original.title}  onClick=
         {e => {
                // e.keyCodeは常に0になる

                setKeyword("#"+cell.row.original.tag[tag]);
                reloadChange();
                setKeyword2("#"+cell.row.original.tag[tag]);
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{"#"+cell.row.original.tag[tag]}  </Button>)
                }
                return tags;
            })()}
          </Typography>
        </Box>
      </Box>
            <Box  bottom="0px" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'relative' }}>
            <Typography variant="h6" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'absolute',right: '0px' }}>
              {cell.row.original.date}
            </Typography>
            </Box>
      </Box>

            </div>
        ),
      },
    ],
    [posts],
  );
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    defaultColumn: {
     // minSize: 1100,
    // width:"100%"
    },
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode:'pages',
    enableSorting: false,
    autosizeColumns:"none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {

      },
    }),
  });


  return (
    <Box noWrap
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
            <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      >
                <Helmet>
                {(() => {
                          const tags = [];
                          for (let i in posts) {
                            tags.push(<meta name="keywords" content={posts[i].title} />)
                if(posts[i].description_key=="description"){
                  tags.push(<meta name="keywords" content={posts[i].description} />)
                }else if(posts[i].description_key=="content"){
                  tags.push(<meta name="keywords" content={posts[i].content} />)
                }
                            for (let j in posts[i].tag) {
                              tags.push(<meta name="keywords" content={posts[i].tag[j]} />)
                            }
                          }
                          return tags;
                        })()}
                {(() => {
                  const tags = [];
                  for (let i in postsSeo) {
                    tags.push(<meta name="keywords" content={postsSeo[i].keyword} />)
                  }
                  return tags;
                })()}
                {(() => {
                  const tags = [];
                  for (let i in postsSeo2) {
                    tags.push(<meta name="keywords" content={postsSeo2[i].title} />)
                            for (let j in postsSeo2[i].tag) {
                              tags.push(<meta name="keywords" content={posts[i].tag[j]} />)
                            }
                    tags.push(<meta name="keywords" content={postsSeo2[i].title} />)
                    tags.push(<meta name="keywords" content={postsSeo2[i].content_sub} />)

                  }
                  return tags;
                })()}
                {(() => {
                  const tags = [];
                  for (let i in postsSeo3) {
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "/news?_id=" + postsSeo3[i]._id} />)
                  }
                  return tags;
                })()}


                </Helmet>
    <Grid container spacing={2}>
    <Grid xs={9}> 

            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            <Container maxWidth={false}>
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00086" })}
              //value={location.state["keyword"]}
              defaultValue={keyword}
              value={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ height:60}}
              onKeyDown={e => {
                // e.keyCodeは常に0になる
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                      ReactGA.event({
                      category: "Search Button",
                      action: "Search Button",
                      label: keyword, // Optional
                });
                  setPage(1);
                  setPageCount(1);
                  reloadChange();
                  //const aaa = document.getElementById("sc");
                  //aaa?.click();
                   //setRefreshKey(old => old + 1);
                }
              }}
            />
            </Container>
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            <Link hidden id="sc" to={"/search?"+getParams} state={{keyword:keyword,category:category}}>テキスト</Link>
      
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Grid container spacing={2}>
    <Grid xs={0.75}> 
    </Grid>
    <Grid xs={11.25}> 
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
      <br/>
      <Container 
        sx={{
          display: 'flex',
        }}
      >
        
                {keyword2 == keyword && <Typography sx={{marginLeft: '-70px' }} variant="h5">{keyword2}</Typography>}
                {keyword2 !== keyword && <Typography sx={{marginLeft: '-70px' }} variant="h5"><FormattedMessage id = "langID00089"/></Typography>}
                <br/><br/><br/>
      </Container>
      </Container>
      
      
      
      
      
      
      
      

    
      <Grid  container spacing={3}>
        {posts.map((article, index) => (

          <Grid wrap="nowrap" xs={4} key={index}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 1,
                height: '95%',
                width:'95%'
              }}
            >
              <Card variant="outlined">
              <CardMedia
                component="img"
                alt="green iguana"
                height="140"
                image={article.img}
              />
              <CardContent>
              <TitleTypography
                row="3"
                gutterBottom
                variant="h6"
                onFocus={() => handleFocus(index)}
                onBlur={handleBlur}
                tabIndex={0}
                className={focusedCardIndex === index ? 'Mui-focused' : ''}
                onClick=
         {e => {
                // e.keyCodeは常に0になる
                // setKeyword("#"+cell.row.original.tag[tag]);
                // reloadChange();
                // setKeyword2("#"+cell.row.original.tag[tag]);
                    ReactGA.event({
                      category: "Click RSS Detail",
                      action: "Click RSS Detail",
                      label: article.title, // Optional
                    });
                    setOpen(true);
                    setDispDate(article.update_time);
                    setDispTitle(article.title);
                    setDispTag(article.tag);
                    if(article.content_key=="description"){
                      setDispContent(article.description);
                    }else if(article.content_key=="content"){
                      setDispContent(article.content);
                    }else if(article.content_key=="both"){
                      setDispContent(article.description + "<br>"+ "<br>"+article.content);
                    }
                    setDispLink(article.link);
                    const url = process.env.REACT_APP_RSS_API_URL;
                    try{
                      let bodyData;
                      bodyData= {
                      category: "17",
                      link: article.link,
                      title:article.title
                      };
                
                  var getParams = new URLSearchParams(params);
                   const headers = new Headers({
                            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
                            'Access-Control-Allow-Credentials': 'true'
                        });
                  var params_str = params.toString();
                  setLoading(true);
                  return fetch(url , {
                      method: 'POST',
                      headers: headers,
                      body: JSON.stringify(bodyData)
                    })
                    .then((response) => {
                      if (!response.ok ){
                        setLoading(false);
                        throw new Error('status is not 200');
                      }
                      return response.json();
                    })
                    .then(jsondata => {
                      setLoading(false);
                      return jsondata;
                    })
                    .catch(error => {
                      setLoading(false);
                    });;
                    setLoading(false);
                    }catch{
                      setLoading(false);
                    }
              }}
              >
                {article.title}
                <NavigateNextRoundedIcon
                  className="arrow"
                  sx={{ fontSize: '1rem' }}
                />
              </TitleTypography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
               {(() => {
                if(article.description_key=="description"){
                  return article.description;
                }else if(article.description_key=="content"){
                  return article.content;
                }
              })()}
              </StyledTypography>
              <Author authors={article.tag} date={ new Date(new Date(article.update_time).getTime() + (9 * 60 * 60 * 1000)).toISOString().substring(0, 10)} />
              </CardContent>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 4, }}>
        <Pagination  hidePrevButton hideNextButton count={pageCount} page={page} onChange={handleChangePage} />
      </Box>
    </Grid>
    </Grid></Grid>
    <Grid xs={3}> 
    <br />
      <Typography variant="h5" gutterBottom>{intl.formatMessage({ id: "langID00090" })}</Typography>

    <List>
    {posts2.map((article, index) => (
                        
       <ListItem>
       {(() => {
                if(index==0){
                  return <span class='badge-gold'> <Crown /> </span>;
                }else if(index==1){
                  return <span class='badge-silver'> <Crown />  </span>;
                }else if(index==2){
                  return <span class='badge-brown'> <Crown />  </span>;
                }else {
                  return <span class='badge-gray badge-warning' id='lblCartCount'> {index+1} </span>;
                }

              })()}
              <Link fullWidth href={article._id.link} to={article._id.link} id={article._id.link} target="_blank"  size="small" style={{  flexWrap: 'wrap',overflowWrap:'break-word',fontSize: '1em' , color: 'black'}}   onClick=
         {e => {
                // e.keyCodeは常に0になる
                // setKeyword("#"+cell.row.original.tag[tag]);
                // reloadChange();
                // setKeyword2("#"+cell.row.original.tag[tag]);
                    ReactGA.event({
                      category: "Click Column RSS",
                      action: "Click Column RSS",
                      label: article._id.title, // Optional
                    });

              }} >{article._id.title}</Link>
      </ListItem>
    ))}
    </List>


    </Grid>
    </Grid>
          <Dialog
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        //PaperComponent={handleClose}
        fullWidth="true"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack my={1} direction="row" justifyContent="end" spacing={1}>
          <IconButton aria-label="delete" onClick={handleClose}  sx={{zIndex: 10001}} >
            <CloseIcon />
          </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Box   sx={{ justifyContent: 'flex-end',top:'0px',position:'relative' }}>
          <h3 class="columnTitle">{dispTitle}</h3><br/>
          <Typography variant="h6" sx={{textAlign: 'right', justifyContent: 'flex-end',top:'40px',position:'absolute',right: '0px' }}>
               {new Date(new Date(dispDate).getTime() + (9 * 60 * 60 * 1000)).toISOString().substring(0, 10)}<br/>     
                              {(() => {
                             const tags = [];
                             for(let i in dispTag){
                                 tags.push(<Button  to="/News" state={{keyword:'#'+dispTag[i]}} noWrap size="small" style={{fontSize: '1em' , color: 'black'}} id={dispTitle} onClick=
                                          {e => {
                                                 // e.keyCodeは常に0になる
                                                 setKeyword("#"+dispTag[i]);
                                                 reloadChange();
                                                 setOpen(false);
                                                 setKeyword2("#"+dispTag[i]);
                                               }} >#{dispTag[i]} </Button>)
                               }
                               return tags;
                           })()}
                         
            </Typography>
            </Box>
              <div style={{ whiteSpace:"pre-wrap" }} className="App">
               <Link to={dispLink} target="_blank">{dispLink}</Link>
                <br /><br />
                <div ref={element} />
              </div>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </Container>
    </Box>
    
  );
}